import { SxProps, Theme } from '@mui/material/styles';

export const menuPaperSx: SxProps<Theme> = {
  maxHeight: 200,
  fontSize: 13,
};
